import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-voucher-coupon-mg-detail',
  templateUrl: './voucher-coupon-mg-detail.component.html',
  styleUrls: ['./voucher-coupon-mg-detail.component.css']
})
export class VoucherCouponMgDetailComponent implements OnInit {
  
  labels = {
    title: ""
  };

  couponVoucherId: string = "";
  cardId: string = "";

  shownTabs = {
    weblog: false,
    use: false,
    emission: false,
    total: 0
  }

  data = {
    weblog: null,
    use: null,
    emission: null    
  }

  currentIndexTab = 0;

  show = {
    tabView: false,
    use: false,
    emission: false,
    weblog: true    
  }

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private srvTranslate: TranslateService    
  ) { }

  ngOnInit() {

    var self = this;

    this.activatedRoute.params.subscribe(params => {                      
      self.couponVoucherId = params['voucherCouponId'];
      self.cardId = params['cardId'];

      self.getVoucherCouponData();
    });
    
  }
  loadData(){    
    
  }
  getVoucherCouponData(){
    
    this.srvTranslate.get(['voucherCouponsMg.titleDetail']).subscribe((res) => {
      this.labels.title = res["voucherCouponsMg.titleDetail"] + (this.couponVoucherId!="" ? " - " +this.couponVoucherId : "");
    });    

    this.getPermissionTabs();
    this.show.tabView = true;  
  }
  onChangeTab(eventChangeTab){    
    this.currentIndexTab = eventChangeTab.index;
    
    if(this.currentIndexTab == 0){
      this.show.weblog = true;
    }
    else if(this.currentIndexTab == 1){
      this.show.emission = true;
    }
    else if(this.currentIndexTab == 2){
      this.show.use = true;
    }
  }  
  onClickBack(){
    this.router.navigate(['/voucher-coupon-mg'],{ queryParams: { cardId: this.cardId, couponVoucherId: this.couponVoucherId }});
  }  
  getPermissionTabs(){    
    //può essere integrato con un servizio che decide quali e quanti tab da visualizzare
    this.shownTabs.emission = true;
    this.shownTabs.use = true;
    this.shownTabs.weblog = true;
    this.shownTabs.total = 3;
  }  
}



// WEBPACK FOOTER //
// ./src/app/views/voucher-coupon-mg/voucher-coupon-mg-detail/voucher-coupon-mg-detail.component.ts